<div class="user-limit-overlay">

    <div class="user-limit-card">

        <div class="user-limit-icon">
            👥
        </div>

        <h1>
            User Limit Exceeded
        </h1>

        <p class="main-message">

            Your subscription user limit has been exceeded.

        </p>

        <div class="limit-count">

            <span class="count">
                {{ exceededUsers }}
            </span>

            <span class="count-label">
                user(s) exceeding the limit
            </span>

        </div>

        <p class="instruction">

            Please deactivate unnecessary users to
            continue using the application.

        </p>

        <button type="button" class="manage-button" (click)="onManageUsers()">

            Manage Users

        </button>

        <p class="admin-message">

            Only an authorized administrator can
            deactivate users.

        </p>

    </div>

</div>